import type { VerbTypes } from 'modules/core/lib/verbTypes'

import Policy from './Policy'

class AttendancePeriodPolicy extends Policy<VerbTypes> {
  checkVerb(verb: VerbTypes): boolean {
    switch (verb) {
      case 'readPeriod':
        return this.permissions.read

      case 'approvePeriod':
        return this.permissions.approve

      case 'editPeriod':
        return this.permissions.edit

      case 'deletePeriod':
        return this.permissions.delete

      default:
        throw new Error(`Unknown verb ${verb} in policy`)
    }
  }
}

export default AttendancePeriodPolicy
